import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, SafeAreaView, Pressable, FlatList, Easing, Dimensions, Image} from 'react-native';

import { Checkbox } from 'react-native-paper';

import GameData from './GameData';

import * as Font from 'expo-font';

import TaskImages from './Images';

const fps = 10;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

class LogScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: false,
    }
	
	GameData.logScreen = this;
  }

	/*
  componentDidMount() {
    this.interval = setInterval(function() {
            this.setState({refresh: !this.state.refresh});
          }.bind(this), fpsDuration);
    }
    
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  */

  renderLog({ item }) {
    let image = null;
    if (item.image) {
      image = <Image style={styles.logImage} source={TaskImages[item.image]} />
    }
	
      return (
        <View style={styles.item}>
            <View style={styles.titleLine}>
              <Text style={styles.life}>{item.life}:  </Text>
              <Text style={styles.title}>{item.title}</Text>
            </View>
            <View style={styles.textLine}>
              <Text style={styles.text}>{item.text}</Text>
              {image}
            </View>
        </View>
      )
  }

  render() {
    return (
      <View style={styles.container}>
        <Text style={styles.screenTitle}>Memoirs</Text>
        <View style={styles.logContainer}>
          <FlatList
            data={GameData.log}
            renderItem={this.renderLog.bind(this)}
			//extraData={this.state.refresh}
			keyExtractor={item => item.title}
            //inverted={true}
          />
        </View>
      </View >
    )
  }
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    flex: 1,
    backgroundColor: '#000000',
  },
  screenTitle: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 24,
    textAlign: 'center',
    borderBottomWidth: 2,
    borderColor: '#ffffff',
  },
  life: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 24,
    textAlign: 'left',
    alignSelf: 'center',
  },
  title: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
    textAlign: 'left',
    alignSelf: 'center',
  },
  text: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 16,
    textAlign: 'left',
  },
  item: {
    margin: 5,
    paddingBottom: 10,
    borderBottomWidth: 2,
    borderColor: '#ffffff',
  },
  titleLine: {
    flexDirection: "row",
  },
  textLine: {
  },
  logImage: {
    marginTop: 10,
    height: 100,
    width: 100,
    alignSelf: 'center',
  },
  logContainer: {
    flex: 1,
  }
});

export default LogScreen;